import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	defaultReportsTitle: {
		id: 'spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.default-reports-title',
		defaultMessage: 'Default',
		description: 'Default Reports Title',
	},
	customReportsTitle: {
		id: 'spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.custom-reports-title',
		defaultMessage: 'Custom',
		description: 'Custom Reports Title',
	},
	workload: {
		id: 'spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.workload',
		defaultMessage: 'Workload',
		description: 'Sidebar menu item for Workload',
	},
	satisfaction: {
		id: 'spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.satisfaction',
		defaultMessage: 'Satisfaction',
		description: 'Sidebar menu item for Satisfaction',
	},
	requestsDeflected: {
		id: 'spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.requests-deflected',
		defaultMessage: 'Requests deflected',
		description: 'Sidebar menu item for Requests deflected',
	},
	requestsResolved: {
		id: 'spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.requests-resolved',
		defaultMessage: 'Requests resolved',
		description: 'Sidebar menu item for Requests resolved',
	},
	analytics: {
		id: 'spa-apps-servicedesk-reports-home-page.controllers.home-page-controller.analytics',
		defaultMessage: 'Atlassian Analytics',
		description: 'Sidebar menu item for Atlassian Analytics',
	},
});
